<!-- 插件料 -->
<template>
  <BaseFormItem
    class="is_plug"
    :label="fields.label"
    :isError="isError"
    :isErrorBlink="isErrorBlink"
  >
    <!-- 焊接插件料 -->
    <BaseRadioGroup v-model="val.is_plug" @change="() => handleEmit('is_plug')">
      <el-radio-button
        v-for="item in fields.options"
        :key="item.value"
        :label="item.value"
      >
        {{ item.label }}
      </el-radio-button>
    </BaseRadioGroup>
    <template v-if="val.is_plug == 1 && [0, 1].includes(Number(patch))">
      <BaseCheckbox 
        class="is_plug__checkbox"
        v-model="val.is_assembly_weld_for_tin"
        :true-label="0"
        :false-label="1"
        @change="() => handleEmit('is_assembly_weld_for_tin')"
      >
        不焊接的插件孔不上锡
      </BaseCheckbox>
      <BaseTipPopover width="340px" :content="tips"></BaseTipPopover>
    </template>
  </BaseFormItem>
</template>

<script>
import { getSMTFields } from '@@/utils/getFields'

export default {
  props: {
    // 焊接插件料
    is_plug: {
      type: Number,
      default: 1
    },
    // 强制不焊接的插件孔不上锡
    is_assembly_weld_for_tin: {
      type: Number,
      default: 0
    },
    // 贴装面（0-仅底层 1-仅顶层 2-双面）
    patch: {
      type: [Number, String],
      default: 2
    }
  },
  data() {
    return {
      val: {
        is_plug: this.is_plug,
        is_assembly_weld_for_tin: this.is_assembly_weld_for_tin
      },
      isError: false, // 是否显示错误提示样式
      isErrorBlink: false, // 是否显示错误提示样式且闪两下
      tips: `工厂常规工艺下：\n
          双面板：默认会对不焊接的插件孔做屏蔽处理，不上锡；\n
          单面板：为节省成本使用万能治具，不焊接的插件孔会自然上锡。\n
          勾选此选项后：无论单 / 双面板，都会按你的要求，对不焊接的插件孔进行不上锡屏蔽处理`
    }
  },
  computed: {
    fields() {
      return getSMTFields('is_plug')
    }
  },
  watch: {
    is_plug(newVal) {
      this.val.is_plug = newVal
    },
    is_assembly_weld_for_tin(newVal) {
      this.val.is_assembly_weld_for_tin = newVal
    },
  },
  methods: {
    handleEmit(key) {
      this.$emit(`update:${key}`, this.val[key])
      this.isShowError(false)
    },
    // 是否显示错误提示样式
    isShowError(isShow, isBlink = false) {
      this.isError = isShow
      this.isErrorBlink = isBlink
    }
  }
}
</script>

<style lang="scss" scoped>
.is_plug {
  .is_plug__checkbox {
    margin: 0 10px;
  }
}
</style>